import { render, staticRenderFns } from "./TagMappings.vue?vue&type=template&id=22f89733&"
import script from "./TagMappings.vue?vue&type=script&lang=ts&"
export * from "./TagMappings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports